export const globalFunction = {
  openWindow: (url) => {
    window.open(url, '_blank');
  }
};
